import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../../Redux";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import { useHistory } from "react-router-dom";

const OrderPaymentsItem = (props) => {
  const pageType = props.location.state;
  // console.log(props.location.state, "lllllllllll");
  const history = useHistory();
  const dispatch = useDispatch();
  const orderPaymentItem = useSelector(
    (state) => state?.financeReducer?.orderPaymentsItemData
  );

  console.log(orderPaymentItem, "orderPaymentItem");

  function handleClick(el) {
    if (el?.is_bundle == 1) {
      dispatch(
        actions?.getOrderPaymentsBundleItemData({
          order_id: orderPaymentItem?.order_id,
          order_item_id: el?.id,
        })
      );
      history.push("/finance/sales/order-payments/bundle-item");
    } else {
      if (pageType === "bill") {
        dispatch(
          actions?.getOrderPaymentsBillsComponentData({
            order_id: orderPaymentItem?.order_id,
            pos_menu_item_id: el?.id,
            bill_id: orderPaymentItem?.bill_id,
            page: orderPaymentItem?.page,
          })
        );
      } else {
        dispatch(
          actions?.getOrderPaymentsComponentData({
            order_id: orderPaymentItem?.order_id,
            order_item_id: el?.id,
          })
        );
      }
      history.push("/finance/sales/order-payments/component");
    }
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  <div className="field text-right my-3 pt-1 px-0">
                    <button
                      onClick={() => history.goBack()}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to {pageType === "bill" ? "Bill" : "Sales"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <h4 class="event-alert">
                            Items{" "}
                            <p class="billno-right">
                              {" "}
                              {pageType === "bill" ? "BILL" : "ORDER"}{" "}
                              #P1150920222
                            </p>
                          </h4>

                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12"></div>
                            <div class="col-sm-auto text-small align-right col-12 mt-2 mt-sm-0">
                              <i>Last Upload July 13, 2022 02:23 PM</i>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Item #</th>
                                    <th>Status</th>
                                    <th>Category</th>
                                    <th>Sub Category</th>
                                    <th>Item Name</th>
                                    <th>Quantity</th>
                                    <th>Item Price</th>
                                    <th>Gross Sales</th>
                                    <th>Discounts</th>
                                    <th>Net Sales</th>
                                    <th className="action-td">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {orderPaymentItem?.menuItems?.map((el) => (
                                    <tr>
                                      <td>{el?.menu_item?.id}</td>
                                      <td>{el?.status}</td>
                                      <td>
                                        {el?.menu_item?.other_category?.name}
                                      </td>
                                      <td>
                                        {el?.menu_item?.sub_category?.name}
                                      </td>
                                      <td>{el?.menu_item?.menu_item_name}</td>
                                      <td>{el?.menu_item_quantity}</td>
                                      <td>{el?.menu_item_price}</td>
                                      <td>{el?.gross_sale}</td>
                                      <td>{el?.discount}</td>
                                      <td>{el?.net_sales}</td>
                                      <td className="action-td">
                                        <a
                                          onClick={() => {
                                            handleClick(el);
                                          }}
                                          class="circle_icon"
                                        >
                                          <i class="iconSprites eye-icon"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default OrderPaymentsItem;
